/**
 * Created by sunjinyu on 2018/11/12.
 */
import axios from 'axios'
axios.defaults.baseURL = '/api';

const instance = axios.create();

//拦截器
instance.interceptors.response.use(res => {
  return res.data.data
}, err => {
  if (!navigator.onLine) {
    err.response.data.status = 110;
    throw err
  } else {
    throw err
  }
});

export const defaultSession = {
  sessionId: sessionStorage.getItem('session_id') || ''
};

// EOS 余额列表
export const getEosRent = () => {
  return instance.get('/eosrent')
};

// 付款
export const sendRentEos = (params) => {
  return instance.post('/eosrent/process', params);
};

// 订单查询
export const orderQuery = (params) => {
  return instance.get(`eosrent/query?id=${encodeURIComponent(params.id)}`)
};

export default axios



// WEBPACK FOOTER //
// ./src/axios/index.js